import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface WaterfallItem {
  name: string;
  value: number;
  isTotal?: boolean;
}

interface WaterfallChartProps {
  categories: string[];
  data: WaterfallItem[];
  height?: number | string;
  loading?: boolean;
}

export function WaterfallChart({ categories, data, height, loading }: WaterfallChartProps) {
  const accum: number[] = [];
  let running = 0;
  for (const d of data) {
    if (d.isTotal) { accum.push(d.value); running = 0; }
    else { accum.push(running); running += d.value; }
  }
  const option: EChartsOption = {
    tooltip: { trigger: 'axis' },
    legend: { bottom: 0 },
    grid: { left: 50, right: 20, top: 20, bottom: 40, containLabel: true },
    xAxis: { type: 'category', data: categories },
    yAxis: { type: 'value' },
    series: [
      { name: 'Accumulate', type: 'bar', stack: 'waterfall', data: accum, itemStyle: { color: 'transparent' } },
      { name: 'Value', type: 'bar', stack: 'waterfall', data: data.map((d) => d.isTotal ? -accum[data.indexOf(d)] : d.value), label: { show: true, position: 'top' } },
    ],
  };
  return <EChart option={option} height={height} loading={loading} />;
}
